const datas = [
  { id: 1, name: "汽車險(任意險)" },
  { id: 5, name: "汽車險(附加傷害險)" },
  { id: 0, name: "汽車險(強制險)" },
  { id: 4, name: "機車險(任意險)" },
  { id: 3, name: "機車險(附加傷害險)" },
  { id: 2, name: "機車險(強制險)" }
];

export default datas;

export const contract_type_enum = window._.keyVal(datas, "id", "name");
